// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ls-0";
export var discountCodeInput = "_ls-1";